// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_kl-6";
export var emphasizeQuantity = "_kl-3";
export var flatBottomCorners = "_kl-5";
export var productImage = "_kl-0";
export var quantityContainer = "_kl-2";
export var tooltip = "_kl-1";
export var wrapAndEllipsesOverflow = "_kl-4";